import {
  ITeamConfig,
  ILeagueConfig,
} from 'fitbeat.models';
import React, { CSSProperties, useState } from 'react';
import TeamListEditor from '../formHelpers/TeamListEditor';
import TeamTable from '../tables/TeamTable';

export interface ITeamsTabProps {
  teamConfigs: ITeamConfig[];
  leagueConfigs: ILeagueConfig[];
  competitionType: string;
  enableLeagues: boolean;
  onAddTeam: (team: ITeamConfig) => void;
  onUpdateTeam: (index: number, team: ITeamConfig) => void;
}

const TeamsTab: React.FC<ITeamsTabProps> = ({
  teamConfigs,
  leagueConfigs,
  competitionType,
  enableLeagues,
  onAddTeam,
  onUpdateTeam,
}) => {
  const [selectedTeamIndex, setSelectedTeamIndex] = useState<number | null>(null);

  const handleSelectTeam = (index: number) => {
    setSelectedTeamIndex(index);
  };

  const handleClearSelection = () => {
    setSelectedTeamIndex(null);
  };

  const handleUpdateTeam = (index: number, team: ITeamConfig) => {
    onUpdateTeam(index, team);
    setSelectedTeamIndex(null);
  };

  return (
    <div style={styles.formRow}>
      {competitionType === 'inter-team' && (
        <>
          <div style={styles.tableCol}>
            <TeamTable
              teams={teamConfigs}
              leagues={leagueConfigs}
              enableLeagues={enableLeagues}
              selectedTeamIndex={selectedTeamIndex}
              onSelectTeam={handleSelectTeam}
            />
          </div>
          <div style={styles.editorCol}>
            <TeamListEditor
              title={selectedTeamIndex !== null ? 'Update Team' : 'Create Team'}
              teams={teamConfigs}
              leagues={leagueConfigs}
              enableLeagues={enableLeagues}
              selectedTeamIndex={selectedTeamIndex}
              onAddTeam={onAddTeam}
              onUpdateTeam={handleUpdateTeam}
              onClearSelection={handleClearSelection}
            />
          </div>
        </>
      )}
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  formRow: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    marginRight: '40px',
  },
  tableCol: {
    width: '80%',
    minWidth: 0,
  },
  editorCol: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: '20%',
    height: 'auto',
    zIndex: 2,
    backgroundColor: '#fff',
    boxShadow: '-2px 0 6px rgba(0, 0, 0, 0.35)',
  },
};

export default TeamsTab;
